import React from 'react';
import ReactDOM from 'react-dom';
import { Redirect, Route } from 'react-router';
import { connect, Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ConnectedRouter } from 'connected-react-router';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'selfly-ui-core/dist/css/index.css';
import 'selfly-ui-core/dist/css/styles.css';
import 'react-sliding-pane/dist/react-sliding-pane.css';

import './index.css';
import i18n from './i18n.js';
import configureStore, { history } from './store.js';
import * as serviceWorker from './serviceWorker.js';
import App from './App.js';
import KeycloakProvider from './components/auth/KeycloakProvider';
import StartupLoader from './components/auth/StartupLoader';
import NoAccess from './components/auth/error/NoAccess';
import { useKeycloak } from '@react-keycloak/web';
import { handleAuthSuccess } from './actions/user';

export const store = configureStore(/* provide initial state if any */);

if (module.hot) {
    module.hot.accept();
}

function AdminRoute({ children, ...rest }) {
    const { keycloak } = useKeycloak();
    const { user } = store.getState();
    const isAnyAdmin = user.profile?.groups?.length
        && (user.isAdmin || user.isReportingOperator || user.isRefillOperator);

    return (
        <Route
            {...rest}
            render={({ location }) => (
                !keycloak.authenticated
                    ? <Redirect to={{ pathname: '/', state: { from: location } }} />
                    : !isAnyAdmin
                        ? <NoAccess />
                        : children
            )}
        />
    );
}

function AppWrapperContainer(props) {
    return (
        <KeycloakProvider
            realm={process.env.REACT_APP_KEYCLOAK_REALM}
            authServerUrl={process.env.REACT_APP_AUTH_URL}
            clientId="scp"
            domainConfiguration={{
                primaryColor: '1c1c1c',
                faviconUrl: 'https://storage.googleapis.com/storage.intelligentfridges.com/selfly-favicon.ico',
                logoLink: 'https://storage.googleapis.com/storage.intelligentfridges.com/selfly-logo.png',
            }}
            handleAuthSuccess={props.handleAuthSuccess}
            isAppInitialized={true}
        >
            <I18nextProvider i18n={i18n}>
                <StartupLoader>
                    <ConnectedRouter history={history}>
                        {/*<Route path="/" component={Landing} />*/}
                        <AdminRoute path="/">
                            <App />
                        </AdminRoute>
                    </ConnectedRouter>
                </StartupLoader>
            </I18nextProvider>
        </KeycloakProvider>
    );
}

const AppWrapper = connect(() => ({}), {
    handleAuthSuccess,
})(AppWrapperContainer);

ReactDOM.render(
    <Provider store={store}>
        <AppWrapper />
    </Provider>,
    document.getElementById('root') || document.createElement('div') // for testing purposes
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
